<template>
  <div id="Footer">
      <div class="row justify-content-between">
          <b-col md="4">
              <span>
                  © 2020 大學光學科技股份有限公司
              </span>
          </b-col>
          <b-col md="6" class="d-flex justify-content-around">
              <span>大學眼鏡偉盟會員</span>
              <span>大學光學</span>
              <span>大學眼科</span>
              <span>大學眼鏡商城</span>
              <span>大學醫美</span>
          </b-col>

      </div>
  </div>
</template>

<script>
  export default {

  }
</script>

<style>
    #Footer {
        color: #93959C   
    }
</style>
